export default {
  fullScreenSvgFill: {
    fill: data => data.color,
  },
};



// WEBPACK FOOTER //
// ./default-modules/ui/controls/full-screen/full-screen.theme.ts